"use strict";;define(function(require,exports,module){const Validation = require('lib/validation');
const User       = require('models/User');

module.exports = {
	data : () => ({
		isCustomRole      : true,
		validationEnabled : true,
	}),

	computed : {
		jobTitle : function() {
			return this.isCustomRole ? 'Other' : this.user.jobTitle;
		},

		actualJobTitle : function() {
			return this.user.jobTitle;
		},

		roles : function() {
			return User.jobTitles;
		},

		validateRole : function() {
			return {
				errorMessage  : this.validationEnabled && Validation.validators.required(this.jobTitle),
				delayMessages : true,
			};
		},

		validateCustomRole : function() {
			return {
				errorMessage  : this.validationEnabled && this.isCustomRole && Validation.validators.required(this.actualJobTitle),
				delayMessages : true,
			};
		},
	},

	created : function() {
		this.isCustomRole = User.current.jobTitle && !User.jobTitles.includes(User.current.jobTitle) || User.current.jobTitle === 'Other';
	},

	methods : {
		handleRoleUpdate : function(val) {
			this.isCustomRole = val === 'Other';
			if (!this.isCustomRole) {
				this.user.jobTitle = val;
			}
			else {
				this.user.jobTitle = '';
			}
		},
	},
};

});